module.exports = __webpack_public_path__ + "media/ekszerteknos_m.31b8429a.mp3";